import React, { useState } from 'react';
import styled from 'styled-components';
import { IoMdArrowDropdown } from 'react-icons/io';


// AccordionWrapper adjustments: removing outer borders
const AccordionWrapper = styled.div`
  margin-bottom: -1px; // Negative margin to overlap borders between accordions
  &:last-child {
    margin-bottom: 0; // Reset for the last item to prevent margin issues
  }
  box-shadow: none; // Remove box-shadow if previously applied
  overflow: hidden; // Keeps child border-radius contained if necessary
`;

// Refine AccordionHeader to include a delicate border, but only between items
const AccordionHeader = styled.div`
  padding: 10px 20px;
  background-color: #f9f9f9; // Light background color for the header
  border-bottom: 2px solid #eaeaea; // Delicate border bottom
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background-color 0.3s ease;

  &:last-child {
    border-bottom: none; // Remove the bottom border for the last header if it’s styled within the AccordionWrapper
  }

  &:hover {
    background-color: #f0f0f0;
  }
`;

// Keeping AccordionContent style for reference
const AccordionContent = styled.div`
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
  padding: 10px 20px;
  text-align: left;
`;

const Rotate = styled.span`
  transition: transform 0.3s ease;
  transform: rotate(${(props) => (props.isOpen ? '180deg' : '0deg')});
`;

const Title = styled.h2`
  margin: 0;
  font-size: 16px;
  color: #333;
`;

const Content = styled.p`
  margin: 0;
  padding: 10px 0;
  font-size: 14px;
  color: #666;
`;








// DataSectionAccordion Component
const DataSectionAccordion = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <AccordionWrapper>
      <AccordionHeader onClick={toggleAccordion}>
        <Title>{title}</Title>
        <Rotate isOpen={isOpen}>
          <IoMdArrowDropdown size='25px' />
        </Rotate>
      </AccordionHeader>
      <AccordionContent isOpen={isOpen}>
        <Content>{content}</Content>
      </AccordionContent>
    </AccordionWrapper>
  );
};

export default DataSectionAccordion;